import { defHttp } from '@/utils/request';
import { JuryModel, JuryPayModel } from './model/juryModel';

interface ListParams {
  page: number;
  size: number;
  name?: string;
  openId?: string;
}

interface JuryModels {
  data: JuryModel[];
  total: number;
}

export const getJuryList = (params: ListParams) =>
  defHttp.get<MergeBaseResponseData<JuryModels>>({
    url: '/countReport/listJury',
    params: params,
  });

export const getPayJury = () =>
  defHttp.get<ListData<JuryPayModel>>({
    url: '/countReport/listJuryPay',
  });

export const queryJury = (juryId) =>
  defHttp.get<ResponseData<JuryModel>>({
    url: '/countReport/queryJury',
    params: {
      juryId,
    },
  });
